import React from 'react';
import { useParentPageContext } from '@/finsight/application/ParentPageContext';
import DealContextProvider from '@/finsight/application/Deal/DealContext';
import { DealTooltipProvider } from '@/finsight/application/Deal/DealTooltipContext';
import { UserPlanType } from '@/users/domain/UserPlan';

export interface ITileWrapperProps {
  children?: React.ReactNode,
  requiredUserPlan?: UserPlanType,
}

export const withTileContext = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const WithTileContext: React.FC<P & ITileWrapperProps> = (props) => {
    const { deals } = useParentPageContext();

    return (
      <DealContextProvider deals={ deals }>
        <DealTooltipProvider>
          <Component { ... props as P } />
        </DealTooltipProvider>
      </DealContextProvider>
    );
  };

  return WithTileContext;
};
